export default __webpack_public_path__ + "static/media/ok.98121a95.svg";